import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import useAuthStore from "../../../services/AuthStore";
import { Delete, Edit } from "@mui/icons-material";

export default function Offices() {
  const { getOffices } = useAuthStore();
  const [offices, setOffices] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentOffice, setCurrentOffice] = useState({
    id: null,
    room_number: "",
  });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    getOffices()
      .then(newOffices => setOffices(newOffices))
      .catch(error => console.error("Ошибка при получении кабинетов:", error));
  }, [getOffices]);

  const handleOpenDialog = (office = { id: null, room_number: "" }) => {
    setCurrentOffice(office);
    setIsEditing(!!office.id);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setCurrentOffice({ id: null, room_number: "" });
  };

  const handleSaveOffice = () => {
    if (isEditing) {
      setOffices(prev =>
        prev.map(office =>
          office.id === currentOffice.id ? currentOffice : office,
        ),
      );
    } else {
      setOffices(prev => [
        ...prev,
        {
          ...currentOffice,
          id: prev.length ? prev[prev.length - 1].id + 1 : 1,
        },
      ]);
    }
    handleCloseDialog();
  };

  const handleDeleteOffice = id => {
    setOffices(prev => prev.filter(office => office.id !== id));
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "room_number", headerName: "Номер кабинета", width: 200 },
    {
      field: "actions",
      headerName: "Действия",
      width: 200,
      renderCell: params => (
        <Box>
          <Button
            size="small"
            variant="contained"
            onClick={() => handleOpenDialog(params.row)}>
            <Edit />
          </Button>
          <Button
            size="small"
            color="error"
            variant="contained"
            onClick={() => handleDeleteOffice(params.row.id)}
            style={{ marginLeft: 8 }}>
            <Delete />
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 16 }}>
        Управление кабинетами
      </Typography>
      <Button
        variant="contained"
        onClick={() => handleOpenDialog()}
        style={{ marginBottom: 16 }}>
        Добавить новый кабинет
      </Button>
      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={offices}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </Box>

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>
          {isEditing ? "Редактировать кабинет" : "Добавить кабинет"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Номер кабинета"
            type="text"
            fullWidth
            value={currentOffice.room_number}
            onChange={e =>
              setCurrentOffice({
                ...currentOffice,
                room_number: e.target.value,
              })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Отмена</Button>
          <Button onClick={handleSaveOffice} variant="contained">
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
